import { render, staticRenderFns } from "./HistoriaClinica.vue?vue&type=template&id=9cc438c6"
import script from "./HistoriaClinica.vue?vue&type=script&lang=js"
export * from "./HistoriaClinica.vue?vue&type=script&lang=js"
import style0 from "./HistoriaClinica.vue?vue&type=style&index=0&id=9cc438c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports